import { useMemo } from 'react';

function getMediaFromFirstVideo(story = null, key = 'media') {
    if (story === null) {
        return null;
    }

    const { components = null, medias = null } = story || {};
    const [firstScreen = null] = components || [];
    const { video = null, background = null } = firstScreen || {};
    const { [key]: videoMedia = null } = video || {};

    const { video: backgroundVideo = null } = background || {};
    const { [key]: backgroundVideoMedia = null } = backgroundVideo || {};

    const videoMediaId = videoMedia || backgroundVideoMedia || null;
    if (videoMediaId === null) {
        return null;
    }
    if (medias !== null && typeof medias[videoMediaId] !== 'undefined') {
        return medias[videoMediaId];
    }
    return null;
}

export function useMicromagVideo(story = null) {
    const video = useMemo(() => {
        return getMediaFromFirstVideo(story, 'media');
    }, [story]);

    const thumbnail = useMemo(() => {
        return getMediaFromFirstVideo(story, 'thumbnail');
    }, [story]);

    const finalMedias = useMemo(() => {
        const { files = null, thumbnail_url: thumbnailUrl = null } = video || {};
        const { h264 = null, webm = null } = files || {};
        const { url: h264url = null } = h264 || {};
        const { url: webmurl = null } = webm || {};
        return [
            { url: webmurl, mime: 'video/webm' },
            { url: h264url, mime: 'video/mp4' },
        ].filter((u) => u !== null);
    }, [video]);

    const finalThumbnail = useMemo(() => {
        const { thumbnail_url: thumbnailUrl = null } = video || {};
        const { sizes = null } = thumbnail || {};
        const { large = null } = sizes || {};
        const { url: thumbUrl = null } = large || {};
        return thumbUrl || thumbnailUrl;
    }, [video, thumbnail]);

    const finalUrl = useMemo(() => {
        return finalMedias.filter((m) => m.mime === 'video/mp4').map((m) => m.url)[0] || null;
    }, [finalMedias]);

    return {
        url: finalUrl,
        medias: finalMedias,
        thumbnail: finalThumbnail,
    };
}

export default useMicromagVideo;
